import organizationServices from "./organization";
import accountServices from "./account";
import configServices from "./config";

async function get() {
  const accountReq = accountServices.list({ offset: 0, limit: 1 });
  const organizationReq = organizationServices.list({ offset: 0, limit: 1 });
  const configReq = configServices.list({ offset: 0, limit: 1 });
  const categoryReq = configServices.list({ offset: 0, limit: 1, filters: { type: 'categories' }});

  return Promise.all([
    accountReq,
    organizationReq,
    categoryReq,
    configReq,
  ]).then(([
    account,
    organization,
    category,
    config
  ]) => {
    return {
      account: account.meta.total,
      organization: organization.meta.total,
      category: category.meta.total,
      object: config.meta.total - category.meta.total,
    }
  }).catch(() => {
    return {
      account: 0,
      organization: 0,
      category: 0,
      object: 0,
    }
  })
}

export default {
  get,
};
